import { render } from "./ContentCard.vue?vue&type=template&id=1b42746e&scoped=true"
import script from "./ContentCard.vue?vue&type=script&lang=js"
export * from "./ContentCard.vue?vue&type=script&lang=js"

import "./ContentCard.vue?vue&type=style&index=0&id=1b42746e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b42746e"]])

export default __exports__